<template>
  <div class="page-common-prompt-message">
    <component :is="view"
               :title="messageResponse.title"
               :content="messageResponse.content"
               :products="messageResponse.products"
               :contact="messageResponse.contact"
    ></component>
  </div>
</template>

<script>
  import { mapGetters } from 'vuex';
  import OrderRecommendProduct from '@/pages/Common/components/OrderRecommendProduct';
  import OrderRecommendContact from '@/pages/Common/components/OrderRecommendContact';
  import { commonLog } from '@/services/app';

  export default {
    name: 'PromptMessage',
    metaInfo: {
      title: '提示',
    },
    components: {
      OrderRecommendProduct,
      OrderRecommendContact,
    },
    computed: {
      ...mapGetters([
        'messageResponse',
      ]),
      view() {
        const { messageResponse } = this;
        const { recommend } = messageResponse;
        switch (recommend) {
          case 'products': {
            return 'OrderRecommendProduct';
          }
          case 'contact': {
            return 'OrderRecommendContact';
          }
          default: {
            commonLog('messageResponseRecommendError', recommend);
            return '';
          }
        }
      },
    },
  };
</script>

<style scoped lang="less">
  @import '~@/assets/styles/var.less';
</style>
